import {useEffect, useState} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import {getCartItemsCount} from "../grohe/groheNavigation/groheFunctions";
import {LOOK_OVERLAYS} from "../core/constants";
import {setLookOverlayOpened} from "../../../actions/lookFunctions";
import {setShowUnlockCalculations} from "../../../actions/unlockCalculationsFunctions";

const WithCartAnimationsChecker = (props) => {

  const {children, fabricatorSettings, isPhoneNumberValidated, setLookOverlayOpened, setShowUnlockCalculations, cartItems,
    instList} = props;
  const [leadPopupWasOpened, setLeadPopupWasOpened] = useState(false);

  const cartItemsLength = getCartItemsCount(cartItems);
  const shouldOpenLeadCapturePopup = fabricatorSettings.leadCaptureShoppingCart && !isPhoneNumberValidated && !!(cartItemsLength || instList.length);

  useEffect(() => {
    if (shouldOpenLeadCapturePopup) {
      setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
      setShowUnlockCalculations(true);
      setLeadPopupWasOpened(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children(leadPopupWasOpened, shouldOpenLeadCapturePopup)
};

const mapStateToProps = (store) => {
  const {isPhoneNumberValidated} = store.userState;
  const {settings} = store.fabricatorState;
  const {cartItems} = store.cartState;
  const {instList} = store.instState;

  return {
    isPhoneNumberValidated,
    fabricatorSettings: settings,
    cartItems,
    instList,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setShowUnlockCalculations,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WithCartAnimationsChecker)
)
